import Vue from 'vue'
import Router from 'vue-router'
import cognito from '@/cognito'
import store from './store'
import Index from '@/components/index'   // Index画面
import Kitora from '@/components/kitora' // Kitora認証画面
import Signin from '@/components/signin' // サインイン画面
import Search from '@/components/search' // エラーレポート検索画面
import Detail from '@/components/detail' // エラーレポート詳細画面
import CONST from './const/const.js'  // 定数
import base64url from "base64url";    // payloadのデコード

Vue.use(Router)

/*
 * サインアウト処理
 */
const signout = (to, from, next) => {
  // サインアウト後の遷移先を設定
  var home = '';
  if(store.state.user) {
    if(store.state.user['group'] === CONST.USER_KBN.DEVELOP) {
      home = '/signin/0';
    } else {
      home = '/kitora/0'; // パラメータ付きURLでない場合はエラーになる
    }
  }

  store.commit('setUser', null);
  cognito.signout();
  next(home);
}

/*
 * 画面遷移の定義
 */
const router = new Router({
  mode: 'history',
  routes: [
    { // Top画面
      path: '/',
      name: 'Index',
      component: Index,
    },
    { // Kitora認証画面
      path: '/kitora/:no',
      name: 'Kitora',
      component: Kitora,
    },
    { // サインイン画面
      path: '/signin/:no',
      name: 'Signin',
      component: Signin,
    },
    { // サインアウト処理
      path: '/signout',
      beforeEnter: signout
    },
    { // 検索画面
      path: '/search',
      name: 'Search',
      component: Search,
      meta: { notRequiredAuth: true } // 認証必須
    },
    { // 詳細画面
      path: '/detail/:no',
      name: 'Detail',
      component: Detail,
      meta: { notRequiredAuth: true }, // 認証必須
    },
    {
      path: '*', // 上記以外のパスが指定（手入力等）された場合は検索画面へ強制遷移
      redirect: 'search'
    },
  ]
})

/*
 * ナビゲーションガード
 * 
 * ルートの遷移前にCognito認証チェックを行い、認証NGの場合は
 * サインイン画面へ戻す
 */
router.beforeResolve(async(to, from, next) => {
console.log('beforeResolve');
console.log(from);
console.log(to);
  // Cognito認証チェック
  cognito.isAuthenticated()
    .then(session => {
      // サインインユーザ名/IDトークンを取得
      const username = session.accessToken.payload.username;
      const token = session.idToken.jwtToken;
      const payload = token.split(".");
      const decodIdToken = JSON.parse(base64url.decode(payload[1]));
      var group = decodIdToken['cognito:groups'][0];

console.log('getAttribute');
      // Cognitoに設定された属性を取得
      cognito.getAttribute()
        .then(result => {
console.log(result);
          var user = {};
          // 取得した属性をユーザー情報に設定
          for(var v of result) {
            user[v.getName()] = v.getValue();
          }
          // サインインユーザ名/IDトークンをユーザー情報に設定
          user['username'] = username;
          user['token'] = token;
          user['group'] = group;
          // storeにユーザー情報を保存
          store.commit('setUser', user);
console.log('store.commit');
console.log(store);

          // 認証＆属性取得がOKの場合は画面遷移
          next();
console.log('画面遷移 - OK');
        })

        // 属性の取得に失敗した場合は異常処理
        .catch(error => { // eslint-disable-line
console.log('getAttribute error');
console.log(error);
          signout(to, from, next);
        })
    })

    // Cognitoの認証エラーの場合
    .catch(error => { // eslint-disable-line
console.log(error);
console.log('Cognitoの認証エラーの場合');
      if (to.matched.some(record => record.meta.notRequiredAuth)) {
console.log('認証チェックが必要');
        // 認証チェックが必要な画面はサインイン画面へ遷移
        signout(to, from, next);
      } else {
console.log('認証チェックが不要');
        store.commit('setUser', null);
        // 認証チェックが不要な画面はそのまま遷移
        next();
      }
    })
})

export default router
